import type { UpdateWhitelabelConfigBody } from "@nlc/shared-types";
import type { UseMutationResult } from "@tanstack/react-query";

import { useMutation, useQueryClient } from "@tanstack/react-query";

import { whitelabelKeys } from "@/hooks/queryKeys";
import apiClient from "@/lib/api/client";

interface UpdateWhitelabelConfigVariables {
  data: UpdateWhitelabelConfigBody;
  id: number;
}

export function useUpdateWhitelabelConfig(): UseMutationResult<
  void,
  Error,
  UpdateWhitelabelConfigVariables
> {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ data, id }: UpdateWhitelabelConfigVariables) =>
      apiClient.url(`/whitelabel/configs/${id}`).patch(data).res(),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: whitelabelKeys.all,
      });
    },
  });
}
